import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search, AlertTriangle } from "lucide-react";
import { ROUTES } from "@/constants/routes";

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(ROUTES.DASHBOARD);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Animation */}
        <div className="relative mb-8">
          <div className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 animate-pulse">
            404
          </div>
          <div className="absolute right-7 mt-5">
            <AlertTriangle className="h-14 w-14 text-yellow-500 animate-bounce" />
          </div>
        </div>

        {/* Error Message */}
        <div className="space-y-4 mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Oops! Trang không tồn tại
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 leading-relaxed">
            Xin lỗi, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
          </p>
          <p className="text-lg text-gray-500 dark:text-gray-400">
            Hãy kiểm tra lại URL hoặc quay về trang chủ để tiếp tục.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={handleGoHome}
            className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-3 text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex items-center gap-2"
          >
            <Home className="h-5 w-5" />
            Về trang chủ
          </Button>

          <Button
            variant="outline"
            onClick={handleGoBack}
            className="border-2 border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white px-8 py-3 text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex items-center gap-2"
          >
            <ArrowLeft className="h-5 w-5" />
            Quay lại
          </Button>
        </div>

        {/* Search Suggestion */}
        <div className="mt-12 p-6 bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Search className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
              Bạn đang tìm kiếm gì?
            </h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { name: "Dashboard", path: "/trang-chu" },
              { name: "Sản phẩm", path: "/products" },
              { name: "Người dùng", path: "/users" },
              { name: "Cài đặt", path: "/settings" },
            ].map((item) => (
              <Button
                key={item.path}
                variant="ghost"
                onClick={() => navigate(item.path)}
                className="hover:cursor-pointer h-12 text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-200 rounded-lg"
              >
                {item.name}
              </Button>
            ))}
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 opacity-20">
          <div className="w-20 h-20 bg-blue-400 rounded-full animate-pulse"></div>
        </div>
        <div className="absolute bottom-20 right-10 opacity-20">
          <div className="w-16 h-16 bg-purple-400 rounded-full animate-pulse delay-300"></div>
        </div>
        <div className="absolute top-1/2 left-5 opacity-10">
          <div className="w-12 h-12 bg-pink-400 rounded-full animate-pulse delay-700"></div>
        </div>
      </div>
    </div>
  );
}
